import React from 'react';
import { Button, Card, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const SingleService = ({service}) => {
    const {id,title,desc,price,img} = service;
    const navigate = useNavigate();
    const  handleDetailNavigation = (id)=>{
        navigate(`/services/${id}`);
    }
    return (
        <Col>
            <Card className='p-3'>
                <Card.Body>
                    <img src={img} alt="" className='img-fluid' />
                    <Card.Title>{title}</Card.Title>
                    <h5 className='my-4'>${price}</h5>
                    <Card.Text className='my-4'>
                        {desc}
                    </Card.Text>
                    <Button onClick={()=> handleDetailNavigation(id)} className='my-4'>Book Now</Button>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default SingleService;